import * as React from 'react';

import { OrganizationSSO } from 'bundles/authentication-common/components/authenticationModal/OrganizationSSO/OrganizationSSO';
import type { Props } from 'bundles/authentication-common/components/authenticationModal/OrganizationSSO/types';
import { AUTHENTICATION_MODAL_MODES } from 'bundles/authentication-common/constants';

const LoginComponent = (props: Props) => (
  <OrganizationSSO {...props} ssoMode={AUTHENTICATION_MODAL_MODES.ORGANIZATIONLOGIN} />
);

export default LoginComponent;
